import { render, staticRenderFns } from "./proView.vue?vue&type=template&id=407a2c96&scoped=true"
import script from "./proView.vue?vue&type=script&lang=js"
export * from "./proView.vue?vue&type=script&lang=js"
import style0 from "./proView.vue?vue&type=style&index=0&id=407a2c96&prod&lang=scss&scoped=true"
import style1 from "./proView.vue?vue&type=style&index=1&id=407a2c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407a2c96",
  null
  
)

export default component.exports